import { __assign, __extends } from "tslib";
import { serializeMessage } from './serializer';
import { BaseCommand, ChatWindowEgressCommand, } from './types';
var ChatInitCommand = /** @class */ (function (_super) {
    __extends(ChatInitCommand, _super);
    function ChatInitCommand(initChatSdkParams) {
        var _this = _super.call(this) || this;
        _this.initChatSdkParams = initChatSdkParams;
        return _this;
    }
    ChatInitCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, payload = _a.initChatSdkParams;
        return {
            cwCmd: ChatWindowEgressCommand.INIT,
            cmdId: cmdId,
            payload: payload,
        };
    };
    return ChatInitCommand;
}(BaseCommand));
export { ChatInitCommand };
var ChatClearCommand = /** @class */ (function (_super) {
    __extends(ChatClearCommand, _super);
    function ChatClearCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChatClearCommand.prototype.toDto = function () {
        var cmdId = this.cmdId;
        return {
            cwCmd: ChatWindowEgressCommand.CLEAR,
            cmdId: cmdId,
        };
    };
    return ChatClearCommand;
}(BaseCommand));
export { ChatClearCommand };
var ChatDisconnectCommand = /** @class */ (function (_super) {
    __extends(ChatDisconnectCommand, _super);
    function ChatDisconnectCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChatDisconnectCommand.prototype.toDto = function () {
        var cmdId = this.cmdId;
        return {
            cwCmd: ChatWindowEgressCommand.DISCONNECT,
            cmdId: cmdId,
        };
    };
    return ChatDisconnectCommand;
}(BaseCommand));
export { ChatDisconnectCommand };
var ChatReconnectCommand = /** @class */ (function (_super) {
    __extends(ChatReconnectCommand, _super);
    function ChatReconnectCommand(reconnectParams) {
        var _this = _super.call(this) || this;
        _this.reconnectParams = reconnectParams;
        return _this;
    }
    ChatReconnectCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, payload = _a.reconnectParams;
        return {
            cwCmd: ChatWindowEgressCommand.RECONNECT,
            cmdId: cmdId,
            payload: payload,
        };
    };
    return ChatReconnectCommand;
}(BaseCommand));
export { ChatReconnectCommand };
var ChatSubscribeToChatRoomsListCommand = /** @class */ (function (_super) {
    __extends(ChatSubscribeToChatRoomsListCommand, _super);
    function ChatSubscribeToChatRoomsListCommand(params) {
        var _this = _super.call(this) || this;
        _this.params = params;
        return _this;
    }
    ChatSubscribeToChatRoomsListCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, payload = _a.params;
        return {
            cwCmd: ChatWindowEgressCommand.CHATLIST_SUB,
            cmdId: cmdId,
            payload: payload,
        };
    };
    return ChatSubscribeToChatRoomsListCommand;
}(BaseCommand));
export { ChatSubscribeToChatRoomsListCommand };
var ChatUnSubscribeToChatRoomsListCommand = /** @class */ (function (_super) {
    __extends(ChatUnSubscribeToChatRoomsListCommand, _super);
    function ChatUnSubscribeToChatRoomsListCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChatUnSubscribeToChatRoomsListCommand.prototype.toDto = function () {
        var cmdId = this.cmdId;
        return {
            cwCmd: ChatWindowEgressCommand.CHATLIST_UNSUB,
            cmdId: cmdId,
        };
    };
    return ChatUnSubscribeToChatRoomsListCommand;
}(BaseCommand));
export { ChatUnSubscribeToChatRoomsListCommand };
var ChatChatRoomsListFetchMoreCommand = /** @class */ (function (_super) {
    __extends(ChatChatRoomsListFetchMoreCommand, _super);
    function ChatChatRoomsListFetchMoreCommand(cursor) {
        var _this = _super.call(this) || this;
        _this.cursor = cursor;
        return _this;
    }
    ChatChatRoomsListFetchMoreCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, cursor = _a.cursor;
        return {
            cwCmd: ChatWindowEgressCommand.CHATLIST_FETCHMORE,
            cmdId: cmdId,
            payload: { cursor: cursor },
        };
    };
    return ChatChatRoomsListFetchMoreCommand;
}(BaseCommand));
export { ChatChatRoomsListFetchMoreCommand };
var ChatSubscribeToChatRoomCommand = /** @class */ (function (_super) {
    __extends(ChatSubscribeToChatRoomCommand, _super);
    function ChatSubscribeToChatRoomCommand(chatroomId) {
        var _this = _super.call(this) || this;
        _this.chatroomId = chatroomId;
        return _this;
    }
    ChatSubscribeToChatRoomCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, chatroomId = _a.chatroomId;
        return {
            cwCmd: ChatWindowEgressCommand.CHATROOM_SUB,
            cmdId: cmdId,
            payload: { chatroomId: chatroomId },
        };
    };
    return ChatSubscribeToChatRoomCommand;
}(BaseCommand));
export { ChatSubscribeToChatRoomCommand };
var ChatUnSubscribeToChatRoomCommand = /** @class */ (function (_super) {
    __extends(ChatUnSubscribeToChatRoomCommand, _super);
    function ChatUnSubscribeToChatRoomCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChatUnSubscribeToChatRoomCommand.prototype.toDto = function () {
        var cmdId = this.cmdId;
        return {
            cwCmd: ChatWindowEgressCommand.CHATROOM_UNSUB,
            cmdId: cmdId,
        };
    };
    return ChatUnSubscribeToChatRoomCommand;
}(BaseCommand));
export { ChatUnSubscribeToChatRoomCommand };
var ChatChatRoomFetchMoreCommand = /** @class */ (function (_super) {
    __extends(ChatChatRoomFetchMoreCommand, _super);
    function ChatChatRoomFetchMoreCommand(cursor) {
        var _this = _super.call(this) || this;
        _this.cursor = cursor;
        return _this;
    }
    ChatChatRoomFetchMoreCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, cursor = _a.cursor;
        return {
            cwCmd: ChatWindowEgressCommand.CHATROOM_FETCHMORE,
            cmdId: cmdId,
            payload: { cursor: cursor },
        };
    };
    return ChatChatRoomFetchMoreCommand;
}(BaseCommand));
export { ChatChatRoomFetchMoreCommand };
var ChatSubscribeToGlobalUnreadCommand = /** @class */ (function (_super) {
    __extends(ChatSubscribeToGlobalUnreadCommand, _super);
    function ChatSubscribeToGlobalUnreadCommand(filter) {
        var _this = _super.call(this) || this;
        _this.filter = filter;
        return _this;
    }
    ChatSubscribeToGlobalUnreadCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, filter = _a.filter;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_SUB_GLOBAL_UNREAD,
            cmdId: cmdId,
            payload: { filter: filter },
        };
    };
    return ChatSubscribeToGlobalUnreadCommand;
}(BaseCommand));
export { ChatSubscribeToGlobalUnreadCommand };
var ChatUnSubscribeGlobalUnreadCommand = /** @class */ (function (_super) {
    __extends(ChatUnSubscribeGlobalUnreadCommand, _super);
    function ChatUnSubscribeGlobalUnreadCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChatUnSubscribeGlobalUnreadCommand.prototype.toDto = function () {
        var cmdId = this.cmdId;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_UNSUB_GLOBAL_UNREAD,
            cmdId: cmdId,
        };
    };
    return ChatUnSubscribeGlobalUnreadCommand;
}(BaseCommand));
export { ChatUnSubscribeGlobalUnreadCommand };
var ChatUnseenSubscribeCommand = /** @class */ (function (_super) {
    __extends(ChatUnseenSubscribeCommand, _super);
    function ChatUnseenSubscribeCommand(filter) {
        var _this = _super.call(this) || this;
        _this.filter = filter;
        return _this;
    }
    ChatUnseenSubscribeCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, payload = _a.filter;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_UNSEEN_SUB,
            cmdId: cmdId,
            payload: payload,
        };
    };
    return ChatUnseenSubscribeCommand;
}(BaseCommand));
export { ChatUnseenSubscribeCommand };
var ChatUnSubscribeUnseenCommand = /** @class */ (function (_super) {
    __extends(ChatUnSubscribeUnseenCommand, _super);
    function ChatUnSubscribeUnseenCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChatUnSubscribeUnseenCommand.prototype.toDto = function () {
        var cmdId = this.cmdId;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_UNSEEN_UNSUB,
            cmdId: cmdId,
        };
    };
    return ChatUnSubscribeUnseenCommand;
}(BaseCommand));
export { ChatUnSubscribeUnseenCommand };
var ChatUnseenMarkSeenCommand = /** @class */ (function (_super) {
    __extends(ChatUnseenMarkSeenCommand, _super);
    function ChatUnseenMarkSeenCommand(filter) {
        var _this = _super.call(this) || this;
        _this.filter = filter;
        return _this;
    }
    ChatUnseenMarkSeenCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, filter = _a.filter;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_UNSEEN_MARK_SEEN,
            cmdId: cmdId,
            payload: filter,
        };
    };
    return ChatUnseenMarkSeenCommand;
}(BaseCommand));
export { ChatUnseenMarkSeenCommand };
var ChatSendMessageCommand = /** @class */ (function (_super) {
    __extends(ChatSendMessageCommand, _super);
    function ChatSendMessageCommand(message) {
        var _this = _super.call(this) || this;
        _this.message = message;
        return _this;
    }
    ChatSendMessageCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, message = _a.message;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_SEND_MSG,
            cmdId: cmdId,
            payload: serializeMessage(message),
        };
    };
    return ChatSendMessageCommand;
}(BaseCommand));
export { ChatSendMessageCommand };
var ChatAddMessageCommand = /** @class */ (function (_super) {
    __extends(ChatAddMessageCommand, _super);
    function ChatAddMessageCommand(params) {
        var _this = _super.call(this) || this;
        _this.params = params;
        return _this;
    }
    ChatAddMessageCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, params = _a.params;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_ADD_MSG,
            cmdId: cmdId,
            payload: params,
        };
    };
    return ChatAddMessageCommand;
}(BaseCommand));
export { ChatAddMessageCommand };
var ChatDeleteMessageCommand = /** @class */ (function (_super) {
    __extends(ChatDeleteMessageCommand, _super);
    function ChatDeleteMessageCommand(messageId) {
        var _this = _super.call(this) || this;
        _this.messageId = messageId;
        return _this;
    }
    ChatDeleteMessageCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, messageId = _a.messageId;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_DELETE_MSG,
            cmdId: cmdId,
            payload: messageId,
        };
    };
    return ChatDeleteMessageCommand;
}(BaseCommand));
export { ChatDeleteMessageCommand };
var ChatNotifyTypingCommand = /** @class */ (function (_super) {
    __extends(ChatNotifyTypingCommand, _super);
    function ChatNotifyTypingCommand(chatroomId, text) {
        var _this = _super.call(this) || this;
        _this.chatroomId = chatroomId;
        _this.text = text;
        return _this;
    }
    ChatNotifyTypingCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, chatroomId = _a.chatroomId, text = _a.text;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_NOTIFY_TYPING,
            cmdId: cmdId,
            payload: { chatroomId: chatroomId, text: text },
        };
    };
    return ChatNotifyTypingCommand;
}(BaseCommand));
export { ChatNotifyTypingCommand };
var ChatNotifyTypingTextChangedCommand = /** @class */ (function (_super) {
    __extends(ChatNotifyTypingTextChangedCommand, _super);
    function ChatNotifyTypingTextChangedCommand(chatroomId, text, isActive) {
        var _this = _super.call(this) || this;
        _this.chatroomId = chatroomId;
        _this.text = text;
        _this.isActive = isActive;
        return _this;
    }
    ChatNotifyTypingTextChangedCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, chatroomId = _a.chatroomId, text = _a.text, isActive = _a.isActive;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_NOTIFY_TYPING,
            cmdId: cmdId,
            payload: { chatroomId: chatroomId, text: text, isActive: isActive },
        };
    };
    return ChatNotifyTypingTextChangedCommand;
}(BaseCommand));
export { ChatNotifyTypingTextChangedCommand };
var ChatDeleteChatroomCommand = /** @class */ (function (_super) {
    __extends(ChatDeleteChatroomCommand, _super);
    function ChatDeleteChatroomCommand(chatroomId) {
        var _this = _super.call(this) || this;
        _this.chatroomId = chatroomId;
        return _this;
    }
    ChatDeleteChatroomCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, chatroomId = _a.chatroomId;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_DELETE_CHATROOM,
            cmdId: cmdId,
            payload: { chatroomId: chatroomId },
        };
    };
    return ChatDeleteChatroomCommand;
}(BaseCommand));
export { ChatDeleteChatroomCommand };
var ChatDeleteChatroomsCommand = /** @class */ (function (_super) {
    __extends(ChatDeleteChatroomsCommand, _super);
    function ChatDeleteChatroomsCommand(chatroomIds) {
        var _this = _super.call(this) || this;
        _this.chatroomIds = chatroomIds;
        return _this;
    }
    ChatDeleteChatroomsCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, chatroomIds = _a.chatroomIds;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_DELETE_CHATROOMS,
            cmdId: cmdId,
            payload: { chatroomIds: chatroomIds },
        };
    };
    return ChatDeleteChatroomsCommand;
}(BaseCommand));
export { ChatDeleteChatroomsCommand };
var ChatSetLastMessageUnreadCommand = /** @class */ (function (_super) {
    __extends(ChatSetLastMessageUnreadCommand, _super);
    function ChatSetLastMessageUnreadCommand(chatroomId) {
        var _this = _super.call(this) || this;
        _this.chatroomId = chatroomId;
        return _this;
    }
    ChatSetLastMessageUnreadCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, chatroomId = _a.chatroomId;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_SET_LAST_MESSAGE_UNREAD,
            cmdId: cmdId,
            payload: { chatroomId: chatroomId },
        };
    };
    return ChatSetLastMessageUnreadCommand;
}(BaseCommand));
export { ChatSetLastMessageUnreadCommand };
var ChatSetAllRoomsAsReadCommand = /** @class */ (function (_super) {
    __extends(ChatSetAllRoomsAsReadCommand, _super);
    function ChatSetAllRoomsAsReadCommand(filter) {
        var _this = _super.call(this) || this;
        _this.filter = filter;
        return _this;
    }
    ChatSetAllRoomsAsReadCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, filter = _a.filter;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_SET_ALL_ROOMS_READ,
            cmdId: cmdId,
            payload: { filter: filter },
        };
    };
    return ChatSetAllRoomsAsReadCommand;
}(BaseCommand));
export { ChatSetAllRoomsAsReadCommand };
var ChatSetMessagesReadCommand = /** @class */ (function (_super) {
    __extends(ChatSetMessagesReadCommand, _super);
    function ChatSetMessagesReadCommand(chatroomId) {
        var _this = _super.call(this) || this;
        _this.chatroomId = chatroomId;
        return _this;
    }
    ChatSetMessagesReadCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, chatroomId = _a.chatroomId;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_SET_MESSAGES_READ,
            cmdId: cmdId,
            payload: { chatroomId: chatroomId },
        };
    };
    return ChatSetMessagesReadCommand;
}(BaseCommand));
export { ChatSetMessagesReadCommand };
var ChatRoomsMessagesReadCommand = /** @class */ (function (_super) {
    __extends(ChatRoomsMessagesReadCommand, _super);
    function ChatRoomsMessagesReadCommand(chatroomIds) {
        var _this = _super.call(this) || this;
        _this.chatroomIds = chatroomIds;
        return _this;
    }
    ChatRoomsMessagesReadCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, chatroomIds = _a.chatroomIds;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_SET_ROOMS_MESSAGES_READ,
            cmdId: cmdId,
            payload: { chatroomIds: chatroomIds },
        };
    };
    return ChatRoomsMessagesReadCommand;
}(BaseCommand));
export { ChatRoomsMessagesReadCommand };
var ChatGetMessagesPageCommand = /** @class */ (function (_super) {
    __extends(ChatGetMessagesPageCommand, _super);
    function ChatGetMessagesPageCommand(chatroomId, messageSequence, pageSize) {
        var _this = _super.call(this) || this;
        _this.chatroomId = chatroomId;
        _this.messageSequence = messageSequence;
        _this.pageSize = pageSize;
        return _this;
    }
    ChatGetMessagesPageCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, chatroomId = _a.chatroomId, messageSequence = _a.messageSequence, pageSize = _a.pageSize;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_GET_MESSAGES_PAGE,
            cmdId: cmdId,
            payload: { chatroomId: chatroomId, messageSequence: messageSequence, pageSize: pageSize },
        };
    };
    return ChatGetMessagesPageCommand;
}(BaseCommand));
export { ChatGetMessagesPageCommand };
var ChatListenRealtimeMessagesCommand = /** @class */ (function (_super) {
    __extends(ChatListenRealtimeMessagesCommand, _super);
    function ChatListenRealtimeMessagesCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChatListenRealtimeMessagesCommand.prototype.toDto = function () {
        var cmdId = this.cmdId;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_LISTEN_REALTIME_MESSAGES,
            cmdId: cmdId,
            payload: {},
        };
    };
    return ChatListenRealtimeMessagesCommand;
}(BaseCommand));
export { ChatListenRealtimeMessagesCommand };
var ChatUnListenRealtimeMessagesCommand = /** @class */ (function (_super) {
    __extends(ChatUnListenRealtimeMessagesCommand, _super);
    function ChatUnListenRealtimeMessagesCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChatUnListenRealtimeMessagesCommand.prototype.toDto = function () {
        var cmdId = this.cmdId;
        return {
            cwCmd: ChatWindowEgressCommand.CHAT_REALTIME_MESSAGES_UNSUB,
            cmdId: cmdId,
        };
    };
    return ChatUnListenRealtimeMessagesCommand;
}(BaseCommand));
export { ChatUnListenRealtimeMessagesCommand };
var WorkerSetThrottleCommand = /** @class */ (function (_super) {
    __extends(WorkerSetThrottleCommand, _super);
    function WorkerSetThrottleCommand(throttle) {
        var _this = _super.call(this) || this;
        _this.throttle = throttle;
        return _this;
    }
    WorkerSetThrottleCommand.prototype.toDto = function () {
        var _a = this, cmdId = _a.cmdId, throttle = _a.throttle;
        return {
            cwCmd: ChatWindowEgressCommand.WORKER_SET_THROTTLE,
            cmdId: cmdId,
            payload: { throttle: throttle },
        };
    };
    return WorkerSetThrottleCommand;
}(BaseCommand));
export { WorkerSetThrottleCommand };
var WorkerResultCommand = /** @class */ (function (_super) {
    __extends(WorkerResultCommand, _super);
    function WorkerResultCommand(resultType, success, payload) {
        var _this = _super.call(this) || this;
        _this.resultType = resultType;
        _this.success = success;
        _this.payload = payload;
        return _this;
    }
    WorkerResultCommand.prototype.toDto = function () {
        var _a = this, resultType = _a.resultType, cmdId = _a.cmdId, success = _a.success, payload = _a.payload;
        return {
            cwCmd: resultType,
            cmdId: cmdId,
            payload: {
                success: success,
                payload: __assign({}, payload),
            },
        };
    };
    return WorkerResultCommand;
}(BaseCommand));
export { WorkerResultCommand };
//# sourceMappingURL=commands.js.map